import { render, staticRenderFns } from "./WareToolInClass.vue?vue&type=template&id=5cf734cc&scoped=true"
import script from "./WareToolInClass.vue?vue&type=script&lang=js"
export * from "./WareToolInClass.vue?vue&type=script&lang=js"
import style0 from "./WareToolInClass.vue?vue&type=style&index=0&id=5cf734cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf734cc",
  null
  
)

export default component.exports